import PriceMatrixEditor from "./PriceMatrixEditor";

export default PriceMatrixEditor;
